import styled from 'styled-components';

import { Field, FieldContainer } from '../../base/Field';
import { mosaiqStyled } from '../../lib';

export const SelectField = mosaiqStyled(Field);

export const SelectContainer = FieldContainer;

export const SelectValue = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SelectArrow = styled.div`
  display: flex;
  align-items: center;
`;
